<template>
    <rkm-modal
        :title="title"
        extra-large
        ref="RkmModal"
    >
        <rkm-table
            :fields="fields"
            :items="items"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            return [
                {key: 'codigo', label: 'Código'},
                {key: 'valorRejeitado', label: 'Valor rejeitado'},
                {key: 'descricao', label: 'Descrição'},
            ]
        },
    },
    created() {
        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.bnafar.gerenciamentoEnvio')
        }
    },
    data: () => ({
        items: [],
        title: 'inconsistências',
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.items = []

            if (item.protocolo) {
                this.title = `inconsistências do protocolo ${item.protocolo}`
            } else {
                this.title = 'inconsistências'
            }

            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            this.setLoading()

            this.repositories.gerenciamentoEnvio.index({acao: 'inconsistencias', id: item.id})
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>